/**
 * Utility functions for trial ID validation to prevent API calls with undefined values
 */

export const validateTrialId = (
  trialId: any,
  context?: string
): string | null => {
  if (!trialId || trialId === "undefined" || trialId === undefined) {
    const contextSuffix = context ? ` in ${context}` : "";
    console.error(
      `Invalid trial ID detected${contextSuffix}: ${String(trialId)}`
    );
    return null;
  }

  if (typeof trialId !== "string") {
    console.warn(
      `Trial ID is not a string${
        context ? ` in ${context}` : ""
      }: ${typeof trialId}, converting...`
    );
    return String(trialId);
  }

  return trialId;
};

export const ensureValidTrialId = (trialId: any, context?: string): string => {
  const validId = validateTrialId(trialId, context);
  if (!validId) {
    const contextSuffix = context ? ` in ${context}` : "";
    throw new Error(`Cannot proceed without valid trial ID${contextSuffix}`);
  }
  return validId;
};

export const isValidTrialId = (trialId: any): boolean => {
  return validateTrialId(trialId) !== null;
};
